export const MILLION = 1000000;

export const COUNTRIES = 'countries';
export const AREA = 'area';
export const SECTOR = 'sector';
export const SUBSECTOR = 'subsector';
export const ESTIMATED_END_DATE = 'estimatedEndDate';
export const AMBIENT_LICENSE = 'ambientalLicense';
export const TOTAL_INVESTMENT = 'totalInvestment';
export const FINANCING = 'financing';
export const PORTFOLIO = 'portafolio';
export const ACCOMPANIMENT = 'acompañamiento';
export const IIRSA_PROJECT_TYPE = 'acción';
export const STAGE = 'etapa';
export const STATE = 'state';
export const STUDIES_STATE = 'estado de estudios';
export const STUDIES_AMOUNT = 'monto de estudios';
export const STUDIES_FINISHED = 'estudios finalizados';
export const END_DATE = 'fecha finalización';
export const TYPE = 'type';
export const AMOUNT = 'amount';
export const SOURCE = 'source';
export const PRIORITIZATION = 'priorización';
